import NavBar from './layout/NavBar.vue'
import SeIcon from './SeIcon.vue'
import PublicIcon from './PublicIcon.vue'
import ChooseLayer from './ChooseLayer.vue'
import SelectLayer from './SelectLayer.vue'
import MPicker from './MPicker.vue'
import Agreement from './Agreement.vue'

const output = {}
output.install = function (Vue) {
  Vue.component(NavBar.name, NavBar)
  Vue.component(SeIcon.name, SeIcon)
  Vue.component(PublicIcon.name, PublicIcon)
  Vue.component(ChooseLayer.name, ChooseLayer)
  Vue.component(SelectLayer.name, SelectLayer)
  Vue.component(MPicker.name, MPicker)
  Vue.component(Agreement.name, Agreement)
}
export default output



// WEBPACK FOOTER //
// ./src/components/index.js